// extracted by mini-css-extract-plugin
export default {"base":"UnstyledButton_base__w4mJx"};